import { Image } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

const BALANCE_GROUP_ORDERS_URL =
  'http://media-cdn.grubhub.com/grubhub-assets/image/upload/v1773311466/corp-management-ui/balance/sRGB%20Group%20Order%20Illustration_png.png';

export function GroupOrdersImage(): JSX.Element {
  const { isPhone } = useScreenSizes();

  return (
    <Image
      width={isPhone ? '100' : '150'}
      src={BALANCE_GROUP_ORDERS_URL}
      alt="illustration"
      aria-label="Group orders"
    />
  );
}
